(() => {
  const mobileQuery = window.matchMedia('(max-width: 749px)');
  const originalMarkupByElement = new WeakMap();

  const initMobileFaq = () => {
    const faqContent = document.querySelector('.sf-default-page__content');
    const isFaqPage = window.location.pathname.replace(/\/$/, '') === '/pages/faq';

    if (!faqContent || !isFaqPage) return;

    if (!originalMarkupByElement.has(faqContent)) {
      originalMarkupByElement.set(faqContent, faqContent.innerHTML);
    }

    faqContent.innerHTML = originalMarkupByElement.get(faqContent);
    faqContent.classList.remove('sf-mobile-faq--enhanced');

    if (!mobileQuery.matches) return;

    faqContent.classList.add('sf-mobile-faq--enhanced');

    faqContent.querySelectorAll('section').forEach((section) => {
      const questions = Array.from(section.querySelectorAll(':scope > h3'));

      questions.forEach((question) => {
        const details = document.createElement('details');
        const summary = document.createElement('summary');
        const answer = document.createElement('div');

        details.className = 'sf-mobile-faq-item';
        answer.className = 'sf-mobile-faq-item__answer';
        summary.innerHTML = question.innerHTML;

        let sibling = question.nextSibling;
        while (sibling) {
          if (sibling.nodeType === Node.ELEMENT_NODE && ['H2', 'H3'].includes(sibling.tagName)) break;

          const nextSibling = sibling.nextSibling;
          answer.appendChild(sibling);
          sibling = nextSibling;
        }

        details.append(summary, answer);
        question.replaceWith(details);
      });
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initMobileFaq, { once: true });
  } else {
    initMobileFaq();
  }

  mobileQuery.addEventListener('change', initMobileFaq);
})();
